import { globalCss } from "./theme.config.js";

const globalStyle = globalCss({
  "*": {
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
    scrollBehavior: "smooth",
    fontFamily: "$font",
  },

  html: {
    overflowX: "hidden",
  },

  body: {
    overflowX: "hidden",
  },

  ".clear": {
    display: "none !important",
  },

  ".hideSmall": {
    "@media only screen and (max-width : 600px)": {
      display: "none",
    },
  },

  ".hideMedium": {
    "@media only screen and (max-width : 900px)": {
      display: "none !important",
    },
  },
});

export default globalStyle;